import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CreatePrivilegeComponent } from '../create-privilege/create-privilege.component';
import { offset } from '@popperjs/core';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-privilege-management',
  templateUrl: './privilege-management.component.html',
  styleUrl: './privilege-management.component.css',
  standalone: false
})
export class PrivilegeManagementComponent implements OnInit {
  action_idx: any = null;

  privileges: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;


  searchedPrivilegeNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;


  @Output() onConfirmClicked = new EventEmitter();

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private authService: AuthService

  ) { }


  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  ngOnInit(): void {

    this.form = this.fb.group({
      name: [''],
      description: [''],
      status: [''],
      offset: [''],
    });

    this.search();
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }


  openDeactivateConfirmModal(id: number, name: string) {

    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Confirm deactivating privilege: " + name + "?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.deactivatePrivilege(id);

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

  }

  openActivateConfirmModal(id: number, name: string) {

    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Confirm activating privilege: " + name + "?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.activatePrivilege(id);

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

  }

  openDeleteConfirmModal(id: number, name: string) {

    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Confirm delete privilege: " + name + "?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.deletePrivilege(id)

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

  }

  deletePrivilege(id: number): void {

    this.isLoading = true
    this.apiService
      .get(`/privileges/delete/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.openSuccessModal('Privilege deleted successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message)
        }
      );

  }

  deactivatePrivilege(id: number): void {

    this.isLoading = true
    this.apiService
      .get(`/privileges/deactivate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.openSuccessModal('Privilege deactivated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message)
        }
      );

  }

  activatePrivilege(id: number): void {

    this.isLoading = true
    this.apiService
      .get(`/privileges/activate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.openSuccessModal('Privilege activated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message)
        }
      );

  }



  openApprovalModal() {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to continue with this process?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {

    this.currentPage = 1;

    this.page = 0;

    this.search()
  }



  search() {

    this.privileges = []
    this.searchedPrivilegeNotFound = false;
    this.isSearching = true;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    formData.append("offset", this.num);
    formData.append("limit", this.selectedLimit);
    formData.append("name", this.form.get('name')?.value || '');
    formData.append("description", this.form.get('description')?.value || '');
    formData.append("status", this.form.get('status')?.value || '');

    this.pageSize = this.selectedLimit

    this.apiService
      .post('/privileges/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.privileges = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedPrivilegeNotFound = true;
          }
        },
        (error) => {

          this.openErrorModal(error?.message)

          this.searchedPrivilegeNotFound = true;
        }
      );
  }



  splitPriviledges(privileges: String): string[] {
    return privileges?.split(',').map((item) => item.trim());
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(CreatePrivilegeComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form',],
      disableClose: true,

      data,
    });

    return dialogRef;
  }

  createPrivilege() {

    let dialogRef = this.openDialogRef();

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.search();
      }

    });
  }


}
